import React, { useEffect, useState } from 'react';
import './dashboard.scss';
import './InfoCard.scss';
import SearchHeader from '../Reuseablecomponent/SearchHeader'
import { resourcesListCount } from '../../customHooks';
import { useDispatch, useSelector } from 'react-redux';
import { DASHBOARD_COUNT_TABLE_DATA_START } from '../../redux/actionsTypes/Types';
import { dashboardCountAction } from '../../redux/actions/DashboardAction';
import { Link, Route } from 'react-router-dom';
const Dashboard = () => {

  const [count, setCount] = useState([])
  const dispatch = useDispatch();
  const { userCount, cvCount, isDataFetch, message } = useSelector(
    (state) => state.master.dashboardCount
  );


  // const getDashboardCount = async() => {
  //   const options = await resourcesListCount("name","id")
  //   setCount(options)
  //   console.log('options', options)

  // }
  useEffect(() => {
    
    dispatch(dashboardCountAction(DASHBOARD_COUNT_TABLE_DATA_START,{}));
    
}, [])
  return (
      <div>
        <SearchHeader title="Dashboard" />
        <div  className="create_Dashboard">
        <div className="mainInfoCard">
        <div className="mainInfoCard__RC">
          <div className="mainInfoCard__RC--card">
          <div className="mainInfoCard__RC--card-body">
              <span className="mainInfoCard__RC--card-body-count mainInfoCard__AC--card-body-count-1"><Link style={{textDecoration:"none"}} to="/resources">{userCount}</Link></span>
            </div>
            <span className="mainInfoCard__RC--card-name"><Link style={{textDecoration:"none"}} to="/resources">Resources Count</Link></span>
          </div>
        </div>
        <div className="mainInfoCard__CVC">
          <div className="mainInfoCard__CVC--card">
          <div className="mainInfoCard__CVC--card-body">
              <span className="mainInfoCard__CVC--card-body-count mainInfoCard__AC--card-body-count-2"><Link style={{textDecoration:"none"}} to="/createdcv">{cvCount}</Link></span>
            </div>
              <span className="mainInfoCard__CVC--card-name"><Link  style={{textDecoration:"none"}} to="/createdcv">CV Created</Link></span>
          </div>
        </div>
        </div>
          
            
          </div>   

            
        </div>
  
    
      );
};

export default Dashboard;
